import { ACTIONS } from 'actions/sheet-info';

const initialState = {
  id: null,
  attempt_location: null,
  showNavigation: false,
  isPerfectHit: false,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.SET_CURRENT_SHEET_LOCATION: {
      const { id, user_node_attempt_location: nodeAttemptLocation } = payload || {};

      return {
        ...state,
        id,
        nodeAttemptLocation,
      };
    }
    case ACTIONS.SET_NAVIGATION_BAR_STATE: {
      const { showNavigation } = payload || {};

      return {
        ...state,
        showNavigation,
      };
    }
    case ACTIONS.SET_PERFECT_HIT: {
      const { isPerfectHit } = payload || {};

      return {
        ...state,
        isPerfectHit,
      };
    }
    default:
      return state;
  }
}
